import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Global } from 'src/app/Service/global.service';
import { SharedService } from 'src/app/Service/shared.service';
import { sp, Web} from "@pnp/sp/presets/all";
import {  NgForm} from '@angular/forms';
declare var $: any;

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
  currentLg ;
  constructor(private global: Global,  private shared: SharedService, private router: Router) {
    sp.setup({
      sp:{
        baseUrl: this.global._basedUrl
      }
    })
   }
  bloc = {
    Titre: "",
    Contenu: ""
  }



  ngOnInit(): void {
    this.global.CurentLanguage.pipe(takeUntil(this.global.navigationEnd)).subscribe(lg => {

      this.currentLg = lg;
      this.shared.getBlocDescriptionByCode(lg.url,'Contact1').subscribe(datas => {
        if(datas !==null) {
          this.bloc.Titre = datas["value"][0].Title;
          this.bloc.Contenu = datas["value"][0].Contenu;
        }
      
      })
    });
  }
  addContact (form:NgForm) {

    let formItems = form.controls
    let list =   Web(this.currentLg.url).lists.getByTitle("Contact");
    const obj = {
      Title: formItems.Nom.value,
      FirstName: formItems.Prenom.value,
      Telephone:formItems.Telephone.value,
      WorkCity:formItems.Ville.value,
      WorkCountry: formItems.Pays.value,
      Email: formItems.Email.value,
      Sujet: formItems.Sujet.value,
      Message:formItems.Message.value
    };
    list.items.add(obj).then(datas => {
    alert('Votre demande a bien été enregistrée !')
      this.resetData(form);
    });

  }
  resetData (f:NgForm) {
    f.resetForm();
  }
  keyPressPhone(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

}
